/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Option_Add_LoadingInputs */

const fr_membership_option_add_loading = /** @type {(inputs: Membership_Option_Add_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajout en cours...`)
};

/**

* @param {Membership_Option_Add_LoadingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_option_add_loading = /** @type {((inputs?: Membership_Option_Add_LoadingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Option_Add_LoadingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_option_add_loading(inputs)
});